import {Component, Input, OnInit, TemplateRef, ViewChild} from '@angular/core';
import { RestUrlsConfig, GenericConfig} from "@signature-it/ngx-generic/config";
import {MatDialog} from "@angular/material/dialog";

@Component({
    selector: 'prod-pic',
    templateUrl: './prod-pic.component.html',
    styleUrls: ['./prod-pic.component.scss'],
    standalone: false
})
export class ProdPicComponent implements OnInit {
    @Input() name;
    @Input() productPic;
    @Input() popular;
    @Input() size = 'Med';
    @Input() dataClasses;
    @Input() dataHref;
    @Input() openPopupOnClick: boolean = false;
    @Input() noImgCalc: boolean = false;
    item;
    imagePopularUrl: string = '';
    @ViewChild('dialogTmp', {static: false}) dialogTmp: TemplateRef<any>;
    CDNPrefix = GenericConfig.CDNPrefix || '';

    constructor(public restUrlsConfig: RestUrlsConfig, public dialog: MatDialog) {
    }


    ngOnInit(): void {
        this.item = {
            'FamilyName_s': this.name,
            'product_pic_s': this.productPic
        };

        if (this.popular) {
            let imagePopular = this.popular.replace('.png', '');
            this.imagePopularUrl = `${this.CDNPrefix}/images/Fittings/${GenericConfig.systemName}/field_images/popular/popular_${imagePopular}_Med.png`;
        }
    }

    openDialog() {
        if(!this.openPopupOnClick) return;
        this.dialog.open(this.dialogTmp, {width: '1000', height: '800'});
    }
}
